'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _button = require('../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

var _mediaButton = require('../../../atoms/media-button');

var _mediaButton2 = _interopRequireDefault(_mediaButton);

var _appBadges = require('../../../atoms/app-badges');

var _appBadges2 = _interopRequireDefault(_appBadges);

var _themeManager = require('../../../../utilities/themeManager');

var _themeManager2 = _interopRequireDefault(_themeManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var ORGANISM_NAME = 'device-hero';

var renderParagraph = function renderParagraph(paragraph) {
  if (paragraph && paragraph.text) {
    return _react2.default.createElement(
      'p',
      { className: ORGANISM_NAME + '__paragraph' },
      htmlToReactParser.parse(paragraph.text)
    );
  }
  return null;
};

var renderMediaButton = function renderMediaButton(mediaButton, isCentered) {
  if (mediaButton && mediaButton.text) {
    var classes = isCentered ? ORGANISM_NAME + '__mediabtn--center' : ORGANISM_NAME + '__mediabtn';

    return _react2.default.createElement(
      _mediaButton2.default,
      {
        id: mediaButton.id,
        color: mediaButton.color,
        className: classes,
        fpti: 'DvcHero-MediaBtn-' + (mediaButton.fpti || mediaButton.text),
        'data-video-id': mediaButton['data-video-id']
      },
      mediaButton.text
    );
  }
  return null;
};

var renderHeadline = function renderHeadline(headline) {
  if (headline) {
    return _react2.default.createElement(
      _heading2.default,
      { level: 2, className: ORGANISM_NAME + '__headline' },
      htmlToReactParser.parse(headline.text)
    );
  }
  return null;
};

var renderCta = function renderCta(cta, isCentered) {
  if (cta && cta.text) {
    var classes = isCentered ? ORGANISM_NAME + '__cta--center' : ORGANISM_NAME + '__cta';

    var targetValue = cta.target || '_self';

    return _react2.default.createElement(
      _button2.default,
      {
        id: cta.id,
        href: cta.href,
        color: cta.color || null,
        className: classes,
        fpti: 'DvcHero-' + (cta.type || 'cta') + '-' + (cta.fpti || cta.text),
        target: targetValue
      },
      cta.text
    );
  }
  return null;
};

var renderHatchText = function renderHatchText(hatchText, isCentered) {
  if (hatchText && hatchText.text) {
    var _cx;

    var classes = (0, _classnames2.default)('pp-sans-small-regular', (_cx = {}, _defineProperty(_cx, ORGANISM_NAME + '__hatch-text--center', isCentered === true), _defineProperty(_cx, ORGANISM_NAME + '__hatch-text', isCentered === false), _cx));

    return _react2.default.createElement(
      'p',
      { className: classes },
      htmlToReactParser.parse(hatchText.text)
    );
  }
  return null;
};

var DeviceHero = function (_React$Component) {
  _inherits(DeviceHero, _React$Component);

  function DeviceHero(props) {
    _classCallCheck(this, DeviceHero);

    var _this = _possibleConstructorReturn(this, (DeviceHero.__proto__ || Object.getPrototypeOf(DeviceHero)).call(this, props));

    _this.renderParagraph = renderParagraph;
    _this.renderMediaButton = renderMediaButton;
    _this.renderHeadline = renderHeadline;
    _this.renderCta = renderCta;
    _this.renderHatchText = renderHatchText;
    return _this;
  }

  _createClass(DeviceHero, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.body.className += ' no-overflow-x';
    }
  }, {
    key: 'renderBadge',
    value: function renderBadge(clientInfo, isCentered) {
      var appBadgeContent = {
        clientInfo: clientInfo,
        ios: this.props.content.ios,
        android: this.props.content.android
      };
      var classes = isCentered ? ORGANISM_NAME + '__app-badge-wrapper--center' : ORGANISM_NAME + '__app-badge-wrapper';

      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(_appBadges2.default, appBadgeContent)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _cx2, _cx3;

      var theme = this.props.config.theme || 'theme-background-image-dark';
      var newProps = (0, _themeManager2.default)(this.props, theme);
      var content = newProps.content,
          config = newProps.config,
          className = newProps.className;
      var headline = content.headline,
          paragraph = content.paragraph,
          mediaButton = content.mediaButton,
          primaryCta = content.primaryCta,
          secondaryCta = content.secondaryCta,
          hatchText = content.hatchText;


      var sectionClasses = (0, _classnames2.default)(ORGANISM_NAME + '-organism', className);
      var heroClasses = (0, _classnames2.default)('' + ORGANISM_NAME, className, theme);

      var clientInfo = this.props.clientInfo;

      var viewport = clientInfo.client_type;

      var backgroundImage = config.backgroundImage && (config.backgroundImage[viewport] || config.backgroundImage.url);

      var deviceImage = config.deviceImage && config.deviceImage.url;

      var deviceImageWrapperClass = config.deviceImageSize === 'large' ? 'col-xl-6 hidden-lg-down' : 'col-md-6 col-xl-4';

      var deviceImageClass = (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, ORGANISM_NAME + '__device-image--large--right', config.deviceImageSize === 'large' && config.textAlign === 'left'), _defineProperty(_cx2, ORGANISM_NAME + '__device-image--large', config.deviceImageSize === 'large'), _defineProperty(_cx2, ORGANISM_NAME + '__device-image--small', config.deviceImageSize === 'small'), _cx2));

      var containerClass = (0, _classnames2.default)((_cx3 = {}, _defineProperty(_cx3, 'container ' + ORGANISM_NAME + '__container--large-padding--right', config.deviceImageSize === 'large' && config.textAlign === 'left'), _defineProperty(_cx3, 'container ' + ORGANISM_NAME + '__container--large-padding', config.deviceImageSize === 'large'), _defineProperty(_cx3, 'container ' + ORGANISM_NAME + '__container--small-padding--right', config.deviceImageSize === 'small' && config.textAlign === 'left'), _defineProperty(_cx3, 'container ' + ORGANISM_NAME + '__container--small-padding', config.deviceImageSize === 'small' && config.textAlign === 'right'), _cx3));

      var contentClass = config.deviceImageSize === 'large' ? ORGANISM_NAME + '__container col-xl-6' : ORGANISM_NAME + '__container col-md-6 col-xl-8';

      var flexItemClass = config.deviceImageSize === 'large' ? ORGANISM_NAME + '__container__content-flex-item--center' : ORGANISM_NAME + '__container__content-flex-item';

      var tabletImageClass = config.deviceImageSize === 'large' ? ORGANISM_NAME + '__device-image-tablet' : 'hidden-xs-up';

      var backgroundPosition = config.backgroundImage && config.backgroundPosition;

      var backgroundImageStyle = backgroundImage ? {
        backgroundImage: 'url(' + backgroundImage + ')',
        backgroundPosition: '' + (backgroundPosition || 'center')
      } : null;

      var deviceImageStyle = {
        backgroundImage: 'url(' + deviceImage + ')'
      };

      var isCentered = config.deviceImageSize === 'large';

      return _react2.default.createElement(
        'section',
        {
          id: config.id ? config.id : null,
          'data-building-block': 'organism',
          className: sectionClasses
        },
        _react2.default.createElement(
          'div',
          { className: heroClasses, style: backgroundImageStyle },
          _react2.default.createElement(
            'div',
            { className: containerClass },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: deviceImageWrapperClass },
                _react2.default.createElement('div', { className: deviceImageClass, style: deviceImageStyle })
              ),
              _react2.default.createElement(
                'div',
                { className: contentClass },
                _react2.default.createElement(
                  'div',
                  { className: ORGANISM_NAME + '__container__content-flex-wrapper' },
                  _react2.default.createElement(
                    'div',
                    { className: flexItemClass },
                    renderHeadline(headline),
                    renderParagraph(paragraph),
                    this.renderBadge(clientInfo, isCentered),
                    renderMediaButton(mediaButton, isCentered),
                    renderCta(primaryCta, isCentered),
                    renderCta(secondaryCta, isCentered),
                    renderHatchText(hatchText, isCentered)
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('img', { src: deviceImage, alt: '', className: tabletImageClass })
        )
      );
    }
  }]);

  return DeviceHero;
}(_react2.default.Component);

exports.default = DeviceHero;


DeviceHero.propTypes = {
  clientInfo: _propTypes2.default.shape({
    client_os_type: _propTypes2.default.string,
    client_is_mobile: _propTypes2.default.bool,
    client_type: _propTypes2.default.string
  }),
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-image-dark', 'theme-background-image-light', 'theme-background-color-blue', 'theme-new-money']),
    backgroundImage: _propTypes2.default.shape({
      url: _propTypes2.default.string.isRequired,
      portable: _propTypes2.default.string.isRequired,
      mobile: _propTypes2.default.string.isRequired
    }),
    backgroundPosition: _propTypes2.default.oneOf(['left', 'center', 'right']),
    deviceImage: _propTypes2.default.shape({
      url: _propTypes2.default.string.isRequired
    }).isRequired,
    deviceImageSize: _propTypes2.default.oneOf(['small', 'large']),
    textAlign: _propTypes2.default.oneOf(['left', 'right']).isRequired
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    ios: _propTypes2.default.shape({
      href: _propTypes2.default.string.isRequired
    }),
    android: _propTypes2.default.shape({
      store: _propTypes2.default.oneOf(['google', 'android-store']),
      href: _propTypes2.default.string.isRequired
    }),
    mediaButton: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      text: _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string,
      'data-video-id': _propTypes2.default.string.isRequired
    }),
    primaryCta: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    secondaryCta: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  }),
  className: _propTypes2.default.string
};

DeviceHero.defaultProps = {
  clientInfo: {
    client_os_type: 'ios',
    client_is_mobile: true,
    client_type: 'dedicated'
  },
  config: {
    id: '',
    backgroundImage: {
      url: '',
      portable: '',
      mobile: ''
    },
    theme: 'theme-background-color-blue',
    backgroundPosition: 'center',
    deviceImage: {
      url: 'https://www.paypalobjects.com/digitalassets/c/website/guideline/deviceimage-flatphone-activity.png'
    },
    deviceImageSize: 'small',
    textAlign: 'right'
  },
  content: {
    headline: {
      text: '21 characters per line - 2 lines maximum.'
    },
    paragraph: {
      text: 'In mobile and tablet views, align text to optimize contrast ' + 'with background image. 152 characters maximum.'
    },
    mediaButton: {
      id: '',
      text: '25 characters maximum',
      'data-video-id': 'lkz4GZgyb9o'
    },
    ios: {
      href: 'https://app.adjust.com/vlx5gy'
    },
    android: {
      store: 'google',
      href: 'https://app.adjust.com/vxullh'
    },
    primaryCta: {
      id: '',
      href: '#',
      text: '29 characters maximum',
      target: '_self'
    },
    secondaryCta: {
      id: '',
      href: '#',
      text: '29 characters maximum',
      target: '_self'
    },
    hatchText: {
      text: '34 characters maximum per line'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/device-hero/jsx/DeviceHero.js
// module id = 1078
// module chunks = 4